export default {"src":"/_next/static/media/home-vision.071a6556.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};